import React, { FC } from 'react'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import Cell from '../../components/Cell'
import Typography from '@components/std-components/Typography'
import formatNumberByLocale from '@utils/format-number-by-locale'

const TotalStores: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    if (!rowData) {
      return <FieldSkeleton />
    }
    const totalStores = Object.keys(get(rowData, column.field) ?? {})?.length ?? 0

    return (
      <Cell>
        <Typography variant='caption2'>{formatNumberByLocale(totalStores)}</Typography>
      </Cell>
    )
  })

export default TotalStores
